<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="viewBox"
    :style="cssVars"
  >
    <g
      :class="`code code_${elementId} codeC ${readOnly ? '' : 'updatable'}`"
      @mouseenter="mouseEnter(`code_${elementId} codeC updatable`)"
      @click="tileClick('C')"
    >
      <path
        :fill="tileBG.c"
        :stroke="tileStrokeColor.c"
        :stroke-width="tileStrokeWidth"
        :d="`M ${viewBoxCenter + viewBoxOverscan} ${viewBoxOverscan}
             L ${viewBoxCenter + halfTileWidth + viewBoxOverscan} ${halfTileWidth + viewBoxOverscan}
             L ${viewBoxCenter + viewBoxOverscan} ${tileWidth + viewBoxOverscan}
             L ${viewBoxCenter - halfTileWidth + viewBoxOverscan} ${halfTileWidth + viewBoxOverscan}
             Z`"
      />
      <text
        :x="viewBoxCenter + viewBoxOverscan"
        :y="tileFontYcorrection + viewBoxOverscan"
        :font-size="tileFontSize"
        text-anchor="middle"
        :fill="textColor"
      >
        C
      </text>
    </g>

    <g
      :class="`code code_${elementId} codeE ${readOnly ? '' : 'updatable'}`"
      @mouseenter="mouseEnter(`code_${elementId} codeE updatable`)"
      @click="tileClick('E')"
    >
      <path
        :fill="tileBG.e"
        :stroke="tileStrokeColor.e"
        :stroke-width="tileStrokeWidth"
        :d="`M ${viewBoxCenter - halfTileWidth - tileSpacing + viewBoxOverscan} ${halfTileWidth + tileSpacing + viewBoxOverscan}
             L ${viewBoxCenter - tileSpacing + viewBoxOverscan} ${viewBoxCenter + viewBoxOverscan}
             L ${viewBoxCenter - halfTileWidth - tileSpacing + viewBoxOverscan} ${viewBoxCenter + halfTileWidth + viewBoxOverscan}
             L ${viewBoxCenter - tileWidth - tileSpacing + viewBoxOverscan} ${tileWidth + tileSpacing + viewBoxOverscan}
             Z`"
      />
      <text
        :x="viewBoxCenter - halfTileWidth - tileSpacing + viewBoxOverscan"
        :y="halfTileWidth + tileSpacing + tileFontYcorrection + viewBoxOverscan"
        :font-size="tileFontSize"
        text-anchor="middle"
        :fill="textColor"
      >
        E
      </text>
    </g>

    <g
      :class="`code code_${elementId} codeO ${readOnly ? '' : 'updatable'}`"
      @mouseenter="mouseEnter(`code_${elementId} codeO updatable`)"
      @click="tileClick('O')"
    >
      <path
        :fill="tileBG.o"
        :stroke="tileStrokeColor.o"
        :stroke-width="tileStrokeWidth"
        :d="`M ${viewBoxCenter + halfTileWidth + tileSpacing + viewBoxOverscan} ${halfTileWidth + tileSpacing + viewBoxOverscan}
             L ${viewBoxCenter + tileWidth + tileSpacing + viewBoxOverscan} ${viewBoxCenter + viewBoxOverscan}
             L ${viewBoxCenter + halfTileWidth + tileSpacing + viewBoxOverscan} ${viewBoxCenter + halfTileWidth + viewBoxOverscan}
             L ${viewBoxCenter + tileSpacing + viewBoxOverscan} ${tileWidth + tileSpacing + viewBoxOverscan}
             Z`"
      />
      <text
        :x="viewBoxCenter + halfTileWidth + tileSpacing + viewBoxOverscan"
        :y="halfTileWidth + tileSpacing + tileFontYcorrection + viewBoxOverscan"
        :font-size="tileFontSize"
        text-anchor="middle"
        :fill="textColor"
      >
        O
      </text>
    </g>

    <g
      :class="`code code_${elementId} codeD ${readOnly ? '' : 'updatable'}`"
      @mouseenter="mouseEnter(`code_${elementId} codeD updatable`)"
      @click="tileClick('D')"
    >
      <path
        :fill="tileBG.d"
        :stroke="tileStrokeColor.d"
        :stroke-width="tileStrokeWidth"
        :d="`M ${viewBoxCenter + viewBoxOverscan} ${viewBoxCenter + tileSpacing + viewBoxOverscan}
             L ${viewBoxCenter + halfTileWidth + viewBoxOverscan} ${viewBoxCenter + tileSpacing + halfTileWidth + viewBoxOverscan}
             L ${viewBoxCenter + viewBoxOverscan} ${viewBoxCenter + tileSpacing + tileWidth + viewBoxOverscan}
             L ${viewBoxCenter - halfTileWidth + viewBoxOverscan} ${viewBoxCenter + tileSpacing + halfTileWidth + viewBoxOverscan}
             Z`"
      />
      <text
        :x="viewBoxCenter + viewBoxOverscan"
        :y="viewBoxCenter + tileSpacing + tileFontYcorrection + viewBoxOverscan"
        :font-size="tileFontSize"
        text-anchor="middle"
        :fill="textColor"
      >
        D
      </text>
    </g>
  </svg>
</template>


<script>
import { nanoid } from 'nanoid';

export default {
  name: 'CodeSVG',
  props: {
    transitionDuration: {
      type: String,
      default: '0.2s',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    tileWidth: {
      type: Number,
      default: 100,
    },
    tileSpacing: {
      type: Number,
      default: 15,
    },
    tileFontSize: {
      type: Number,
      default: 45,
    },
    tileFontYcorrection: {
      type: Number,
      default: 65,
    },
    tileZoomScale: {
      type: Number,
      default: 1.9,
    },
    tileZoomScaleCorrection: {
      type: Number,
      default: 13, // zoom 2.0
      // default: 55, // zoom 3.0
    },
    selectedTileZoomScale: {
      type: Number,
      default: 1.9,
    },
    tileBG: {
      type: Object,
      default() {
        return {
          c: '#2cc6ff',
          o: '#ff8c2a',
          d: '#98d94c',
          e: '#ff5d65',
        };
      },
    },
    tileStrokeColor: {
      type: Object,
      default() {
        return {
          c: '#2cc6ff',
          o: '#ff8c2a',
          d: '#98d94c',
          e: '#ff5d65',
          // c: 'black',
          // o: 'black',
          // d: 'black',
          // e: 'black',
        };
      },
    },
    tileStrokeWidth: {
      type: Number,
      default: 0,
    },
    textColor: {
      type: String,
      default: 'white',
    },

    selectedTile: {
      type: String,
      default: '',
    },
    selectedTileColor: {
      type: Object,
      default() {
        return {
          c: '#2cc6ff',
          o: '#ff8c2a',
          d: '#98d94c',
          e: '#ff5d65',
        };
      },
    },
    selectedTileStrokeColor: {
      type: Object,
      default() {
        return {
          // c: '#2cc6ff',
          // o: '#ff8c2a',
          // d: '#98d94c',
          // e: '#ff5d65',
          c: 'black',
          o: 'black',
          d: 'black',
          e: 'black',
        };
      },
    },
    selectedTileStrokeWidth: {
      type: Number,
      default: 0,
    },
    selectedTileLabelColor: {
      type: String,
      default: 'white',
    },
    // This adds a stroke to the label, making it larger (bolder).
    // set to '' to disable this feature
    selectedTileLabelStrokeColor: {
      type: String,
      default: 'white',
    },
    selectedInwardPixels: {
      type: Number,
      default: 60,
    },

    hoverTileStrokeColor: {
      type: Object,
      default() {
        return {
          // c: '#2cc6ff',
          // o: '#ff8c2a',
          // d: '#98d94c',
          // e: '#ff5d65',
          c: 'black',
          o: 'black',
          d: 'black',
          e: 'black',
        };
      },
    },
    hoverTileStrokeWidth: {
      type: Number,
      default: 0,
    },
    hoverTileColor: {
      type: Object,
      default() {
        return {
          c: '#2cc6ff',
          o: '#ff8c2a',
          d: '#98d94c',
          e: '#ff5d65',
        };
      },
    },
  },

  data() {
    return {
      code: {},
      selectedTileSelector: '',
      elementId: nanoid(5),
    };
  },

  mounted() {
    if (this.selectedTile === '') return;
    if (!this.isSelectedTileValid()) return;
    this.updateSelectedTile();
  },

  watch: {
    selectedTile() {
      if (this.selectedTile === '') {
        this.tileDeSelect(this.selectedTileSelector);
        return;
      }

      if (this.selectedTile !== '' && !this.isSelectedTileValid()) return;

      this.updateSelectedTile();
    },
  },

  computed: {
    viewBoxWidth() {
      return ((2 * this.tileWidth) + (2 * this.tileSpacing));
    },
    viewBoxOverscan() {
      return (((this.tileWidth * this.tileZoomScale) / 2) - (this.tileWidth / 2) + 15);
    },
    viewBoxWidthWithOverscan() {
      return ((2 * this.tileWidth) + (2 * this.tileSpacing) + (2 * this.viewBoxOverscan));
    },
    viewBoxCenter() {
      return this.viewBoxWidth / 2;
    },
    viewBox() {
      return `0 0 ${this.viewBoxWidthWithOverscan} ${this.viewBoxWidthWithOverscan}`;
    },
    halfTileWidth() {
      return this.tileWidth / 2;
    },

    cssVars() {
      const correction = this.tileZoomScaleCorrection + (this.tileWidth * this.tileZoomScale / 4);
      const hoverTransformC = `translate(0px, ${correction}px) scale(${this.tileZoomScale})`;
      const hoverTransformO = `translate(-${correction}px, 0px) scale(${this.tileZoomScale})`;
      const hoverTransformD = `translate(0px, -${correction}px) scale(${this.tileZoomScale})`;
      const hoverTransformE = `translate(${correction}px, 0px) scale(${this.tileZoomScale})`;

      // eslint-disable-next-line
      const selectedCorrection = ((((this.tileWidth * this.selectedTileZoomScale) - this.tileWidth) / 2) + this.selectedInwardPixels);
      const selectedTransformC = `translate(0px, ${selectedCorrection}px) scale(${this.selectedTileZoomScale})`;
      const selectedTransformO = `translate(-${selectedCorrection}px, 0px) scale(${this.selectedTileZoomScale})`;
      const selectedTransformD = `translate(0px, -${selectedCorrection}px) scale(${this.selectedTileZoomScale})`;
      const selectedTransformE = `translate(${selectedCorrection}px, 0px) scale(${this.selectedTileZoomScale})`;

      return {
        '--hoverTransformC': hoverTransformC,
        '--hoverTransformO': hoverTransformO,
        '--hoverTransformD': hoverTransformD,
        '--hoverTransformE': hoverTransformE,

        '--selectedTransformC': selectedTransformC,
        '--selectedTransformO': selectedTransformO,
        '--selectedTransformD': selectedTransformD,
        '--selectedTransformE': selectedTransformE,

        '--transitionDuration': this.transitionDuration,

        '--hoverTileStrokeColorC': this.hoverTileStrokeColor.c,
        '--hoverTileStrokeColorO': this.hoverTileStrokeColor.o,
        '--hoverTileStrokeColorD': this.hoverTileStrokeColor.d,
        '--hoverTileStrokeColorE': this.hoverTileStrokeColor.e,
        '--hoverTileStrokeWidth': this.hoverTileStrokeWidth,

        '--hoverTileColorC': this.hoverTileColor.c,
        '--hoverTileColorO': this.hoverTileColor.o,
        '--hoverTileColorD': this.hoverTileColor.d,
        '--hoverTileColorE': this.hoverTileColor.e,

        '--selectedTileStrokeColorC': this.selectedTileStrokeColor.c,
        '--selectedTileStrokeColorO': this.selectedTileStrokeColor.o,
        '--selectedTileStrokeColorD': this.selectedTileStrokeColor.d,
        '--selectedTileStrokeColorE': this.selectedTileStrokeColor.e,
        '--selectedTileStrokeWidth': this.selectedTileStrokeWidth,

        '--selectedTileColorC': this.selectedTileColor.c,
        '--selectedTileColorO': this.selectedTileColor.o,
        '--selectedTileColorD': this.selectedTileColor.d,
        '--selectedTileColorE': this.selectedTileColor.e,
        '--selectedTileLabelColor': this.selectedTileLabelColor,
        '--selectedTileLabelStrokeColor': this.selectedTileLabelStrokeColor,
      };
    },
  },

  methods: {
    isSelectedTileValid() {
      const validValues = ['c', 'o', 'd', 'e'];
      if (!validValues.includes(this.selectedTile)) {
        if (this.selectedTileSelector !== '') this.tileDeSelect(this.selectedTileSelector);
        console.error(`Invalid value "${this.selectedTile}" for "selectedTile" property. Valid values: ${validValues}`);
        return false;
      }
      return true;
    },
    updateSelectedTile() {
      const selector = `code_${this.elementId} code${this.selectedTile.toUpperCase()}`;
      this.bringElemToFront(selector);
      this.tileSelect(selector);
    },
    mouseEnter(selector) {
      if (this.readOnly || this.selectedTileSelector !== '') return;
      this.bringElemToFront(selector);
    },
    bringElemToFront(selector) {
      const tileElem = document.getElementsByClassName(selector);
      tileElem[0].parentNode.appendChild(tileElem[0]);
    },
    tileClick(label) {
      if (this.readOnly) return;

      const selector = `code_${this.elementId} code${label}`;
      if (this.selectedTileSelector === selector) {
        this.tileDeSelect(selector);
        this.$emit('newSelection', '');
        return;
      }

      this.tileSelect(selector);
      this.$emit('newSelection', label.toLowerCase());
    },
    tileSelect(selector) {
      if (this.selectedTileSelector !== '') {
        this.tileDeSelect(this.selectedTileSelector);
      }

      const tiles = ['codeC', 'codeO', 'codeD', 'codeE'];
      tiles.forEach(tile =>
        document.getElementsByClassName(`code code_${this.elementId} ${tile}`)[0].classList.remove('updatable'));

      this.selectedTileSelector = selector;
      document.getElementsByClassName(selector)[0].classList.add('selected');
    },
    tileDeSelect(selector) {
      if (selector === '') return;

      if (this.selectedTileSelector === selector) {
        this.selectedTileSelector = '';
        document.getElementsByClassName(selector)[0].classList.remove('selected');

        const tiles = ['codeC', 'codeO', 'codeD', 'codeE'];
        tiles.forEach(tile =>
          document.getElementsByClassName(`code code_${this.elementId} ${tile}`)[0].classList.add('updatable'));
      }
    },
  },
};
</script>

<style scoped>
  g.code {
    pointer-events: all;
    transition: var(--transitionDuration);
    transform-origin: center;
    cursor: pointer;
  }

  g.code.codeC.selected {
    fill: var(--selectedTileColorC);
    stroke: var(--selectedTileStrokeColorC);
    transform: var(--selectedTransformC);
    filter: drop-shadow(0px 0px 8px var(--selectedTileStrokeColorC));
  }
  g.code.codeO.selected {
    fill: var(--selectedTileColorO);
    stroke: var(--selectedTileStrokeColorO);
    transform: var(--selectedTransformO);
    filter: drop-shadow(0px 0px 8px var(--selectedTileStrokeColorO));
  }
  g.code.codeD.selected {
    fill: var(--selectedTileColorD);
    stroke: var(--selectedTileStrokeColorD);
    transform: var(--selectedTransformD);
    filter: drop-shadow(0px 0px 8px var(--selectedTileStrokeColorD));
  }
  g.code.codeE.selected {
    fill: var(--selectedTileColorE);
    stroke: var(--selectedTileStrokeColorE);
    transform: var(--selectedTransformE);
    filter: drop-shadow(0px 0px 8px var(--selectedTileStrokeColorE));
  }

  g.code.codeC.selected path {
    fill: var(--selectedTileColorC);
    stroke: var(--selectedTileStrokeColorC);
    stroke-width: var(--selectedTileStrokeWidth);
  }
  g.code.codeO.selected path {
    fill: var(--selectedTileColorO);
    stroke: var(--selectedTileStrokeColorO);
    stroke-width: var(--selectedTileStrokeWidth);
  }
  g.code.codeD.selected path {
    fill: var(--selectedTileColorD);
    stroke: var(--selectedTileStrokeColorD);
    stroke-width: var(--selectedTileStrokeWidth);
  }
  g.code.codeE.selected path {
    fill: var(--selectedTileColorE);
    stroke: var(--selectedTileStrokeColorE);
    stroke-width: var(--selectedTileStrokeWidth);
  }

  g.code.selected text {
    fill: var(--selectedTileLabelColor);
    stroke: var(--selectedTileLabelStrokeColor);
  }

  g.code.codeC.updatable:hover path {
    fill: var(--hoverTileColorC);
    stroke: var(--hoverTileStrokeColorC);
    stroke-width: var(--hoverTileStrokeWidth);
  }
  g.code.codeO.updatable:hover path {
    fill: var(--hoverTileColorO);
    stroke: var(--hoverTileStrokeColorO);
    stroke-width: var(--hoverTileStrokeWidth);
  }
  g.code.codeD.updatable:hover path {
    fill: var(--hoverTileColorD);
    stroke: var(--hoverTileStrokeColorD);
    stroke-width: var(--hoverTileStrokeWidth);
  }
  g.code.codeE.updatable:hover path {
    fill: var(--hoverTileColorE);
    stroke: var(--hoverTileStrokeColorE);
    stroke-width: var(--hoverTileStrokeWidth);
  }

  g.code.codeC.selected.updatable:hover path {
    animation: none;
    fill: var(--selectedTileColorC);
    stroke: var(--selectedTileStrokeColor);
    stroke-width: var(--selectedTileStrokeWidth);
  }
  g.code.codeO.selected.updatable:hover path {
    fill: var(--selectedTileColorO);
    stroke: var(--selectedTileStrokeColor);
    stroke-width: var(--selectedTileStrokeWidth);
  }
  g.code.codeD.selected.updatable:hover path {
    fill: var(--selectedTileColorD);
    stroke: var(--selectedTileStrokeColor);
    stroke-width: var(--selectedTileStrokeWidth);
  }
  g.code.codeE.selected.updatable:hover path {
    fill: var(--selectedTileColorE);
    stroke: var(--selectedTileStrokeColor);
    stroke-width: var(--selectedTileStrokeWidth);
  }

  g.code.codeC.updatable:hover {
    transform: var(--hoverTransformC);
    filter: drop-shadow(0px 0px 8px var(--hoverTileStrokeColorC));
  }
  g.code.codeO.updatable:hover {
    transform: var(--hoverTransformO);
    filter: drop-shadow(0px 0px 8px var(--hoverTileStrokeColorO));
  }
  g.code.codeD.updatable:hover {
    transform: var(--hoverTransformD);
    filter: drop-shadow(0px 0px 8px var(--hoverTileStrokeColorD));
  }
  g.code.codeE.updatable:hover {
    transform: var(--hoverTransformE);
    filter: drop-shadow(0px 0px 8px var(--hoverTileStrokeColorE));
  }
</style>
